import { c as _c } from "react/compiler-runtime";
import { IconProps } from '../types';
export function MbLogo(t0) {
  const $ = _c(6);
  const {
    width: t1,
    height: t2,
    fill: t3
  } = t0;
  const width = t1 === undefined ? 24 : t1;
  const height = t2 === undefined ? 24 : t2;
  const fill = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[0] !== fill) {
    t4 = <path d="M103.127 95.1846H77.2576V14.2666H103.127V95.1846ZM35.2439 95.1836H9.37476V48.6562H35.2439V95.1836ZM74.3826 46.8799L56.2263 64.8926L22.1501 32.0762L40.3064 14.0625L74.3826 46.8799Z" fill={fill} />;
    $[0] = fill;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== height || $[3] !== t4 || $[4] !== width) {
    t5 = <svg width={width} height={height} viewBox="0 0 113 113" fill="none" xmlns="http://www.w3.org/2000/svg">{t4}</svg>;
    $[2] = height;
    $[3] = t4;
    $[4] = width;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}